import { useTradeSalesStore } from "@fero/stores";
import type { ProductSalePriceInfo } from "adl-gen/ferovinum/app/api";

/**
 * Helper hook to provide helper methods and strongly typed access to trade sale state
 *  - Nominated Purchaser can be strongly typed since this hook should never be used outside of the trade sale flow
 */
export const useTradeSaleHelpers = () => {
  const options = useTradeSalesStore((state) => state.options);

  if (!options.nominatedPurchaser) {
    throw new Error("Nominated purchaser is not set");
  }

  const getSalePrice = (productSalePrice?: ProductSalePriceInfo) => {
    if (!productSalePrice) {
      return 0;
    }

    switch (options.salePriceType) {
      case "exDutyAndVat":
        return Number(productSalePrice.exDutyAndVatPrice);
      case "incDutyAndVat":
        return Number(productSalePrice.incDutyAndVatPrice);
      case "incDutyExVat":
        return Number(productSalePrice.incDutyExVatPrice);
      default:
        return null;
    }
  };

  const getSalePriceLabel = () => {
    switch (options.salePriceType) {
      case "exDutyAndVat":
        return "(Ex Duty, Ex VAT)";
      case "incDutyAndVat":
        return "(Inc Duty, Inc VAT)";
      case "incDutyExVat":
        return "(Inc Duty, Ex VAT)";
      default:
        return "(Ex Duty, Ex VAT)";
    }
  };

  return {
    nominatedPurchaser: options.nominatedPurchaser,
    nominatedPurchaserId: options.nominatedPurchaser.nominatedPurchaserId,
    storageLocationId: options.storageLocation
      ? options.storageLocation.id
      : "",
    getSalePrice,
    getSalePriceLabel,
  };
};
